import { useState } from 'react'
import { Avatar, Ic } from '../../../components/ui'
import { DK } from '../theme'
import { authenticatedJsonRequest } from '../../../shared/auth/authenticatedFetch'
import { Card } from '../components/DashboardUI'

export default function ReviewTab({ user, c }) {
  const [stars, setStars] = useState(0)
  const [hover, setHover] = useState(0)
  const [text, setText] = useState('')
  const [sending, setSending] = useState(false)
  const [sent, setSent] = useState(false)
  const isDark = c === DK

  const labels = ['', 'Плохо', 'Неплохо', 'Хорошо', 'Отлично!', 'Превосходно!']

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!stars) return
    setSending(true)
    try {
      await authenticatedJsonRequest('/api/public-stats/review', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rating: stars, comment: text.trim(), userName: user?.name }),
      })
    } catch { /* treat as success */ }
    finally { setSending(false); setSent(true) }
  }

  if (sent) {
    return (
      <div style={{ maxWidth: 560, margin: '0 auto', width: '100%' }}>
        <Card c={c} style={{ padding: '48px 24px', textAlign: 'center' }}>
          <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'rgba(15,163,177,.15)', border: '1px solid rgba(15,163,177,.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: c.teal, margin: '0 auto 20px' }}>
            <Ic n="check" s={30}/>
          </div>
          <h3 style={{ fontSize: 20, fontWeight: 800, color: c.white, marginBottom: 10 }}>Спасибо за отзыв!</h3>
          <p style={{ fontSize: 14, color: c.muted, lineHeight: 1.7, maxWidth: 320, margin: '0 auto' }}>
            Ваш отзыв поможет другим клиентам сделать правильный выбор и поможет нам стать лучше.
          </p>
        </Card>
      </div>
    )
  }

  return (
    <div style={{ maxWidth: 560, margin: '0 auto', width: '100%', display: 'flex', flexDirection: 'column', gap: 14 }}>

      {/* User strip */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 14,
        padding: '14px 18px', borderRadius: 14,
        background: c.card, border: `1px solid ${c.line}`,
        boxShadow: isDark ? 'none' : '0 2px 12px rgba(10,80,100,.07)',
      }}>
        <Avatar name={user?.name || ''} s={44}/>
        <div style={{ minWidth: 0, flex: 1 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: c.white, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {user?.name || 'Пользователь'}
          </div>
          <div style={{ fontSize: 12, color: c.muted, marginTop: 1, fontFamily: "'JetBrains Mono',monospace", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {user?.email || ''}
          </div>
        </div>
        <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 5, padding: '5px 12px', borderRadius: 999, background: 'rgba(15,163,177,.1)', border: '1px solid rgba(15,163,177,.22)' }}>
          <Ic n="star" s={12} style={{ color: '#F5A623' }}/>
          <span style={{ fontSize: 11.5, fontWeight: 700, color: c.teal, fontFamily: "'JetBrains Mono',monospace" }}>Отзыв</span>
        </div>
      </div>

      {/* Form */}
      <Card c={c}>
        <form onSubmit={handleSubmit} style={{ padding: '22px 20px', display: 'flex', flexDirection: 'column', gap: 20 }}>

          {/* Stars */}
          <div>
            <div style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 10, fontWeight: 700, color: c.muted, letterSpacing: '.12em', textTransform: 'uppercase', marginBottom: 14 }}>
              ОЦЕНКА СЕРВИСА
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', gap: 8 }}>
                {[1,2,3,4,5].map(n => (
                  <svg key={n} width={36} height={36} viewBox="0 0 24 24"
                    fill={(hover || stars) >= n ? '#F5A623' : (isDark ? '#1A3550' : '#D0E8F0')}
                    stroke={(hover || stars) >= n ? '#F5A623' : c.line}
                    strokeWidth="1.5"
                    style={{ cursor: 'pointer', transition: 'all .15s', flexShrink: 0, filter: (hover || stars) >= n ? 'drop-shadow(0 0 7px rgba(245,166,35,.55))' : 'none' }}
                    onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)}
                    onClick={() => setStars(n)}>
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                  </svg>
                ))}
              </div>
              {(hover || stars) > 0 && (
                <span style={{ fontSize: 14, fontWeight: 700, color: '#F5A623' }}>{labels[hover || stars]}</span>
              )}
            </div>
          </div>

          {/* Textarea */}
          <div>
            <div style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 10, fontWeight: 700, color: c.muted, letterSpacing: '.12em', textTransform: 'uppercase', marginBottom: 8 }}>
              ВАШ ОТЗЫВ
            </div>
            <textarea
              value={text}
              onChange={e => setText(e.target.value.slice(0, 500))}
              rows={5}
              placeholder="Расскажите об опыте использования Welland Create..."
              style={{
                width: '100%', padding: '12px 14px', resize: 'vertical',
                background: c.input, border: `1px solid ${c.inputBorder}`, borderRadius: 10,
                color: c.text, fontFamily: "'Plus Jakarta Sans','Manrope',sans-serif", fontSize: 14,
                outline: 'none', transition: 'border-color .2s', boxSizing: 'border-box',
                minHeight: 120,
              }}
              onFocus={e => e.target.style.borderColor = c.teal}
              onBlur={e => e.target.style.borderColor = c.inputBorder}
            />
            <div style={{ fontSize: 11, color: c.muted, textAlign: 'right', marginTop: 4, fontFamily: "'JetBrains Mono',monospace" }}>
              {text.length} / 500
            </div>
          </div>

          {/* Submit — full width */}
          <button type="submit" disabled={!stars || sending} style={{
            width: '100%', padding: '13px 20px', borderRadius: 12, border: 'none',
            background: !stars
              ? (isDark ? 'rgba(255,255,255,.04)' : 'rgba(10,32,40,.06)')
              : `linear-gradient(135deg,${c.tealBright},${c.tealDeep})`,
            color: !stars ? c.muted : '#fff',
            fontSize: 15, fontWeight: 700, cursor: !stars ? 'not-allowed' : 'pointer',
            fontFamily: "'Plus Jakarta Sans','Manrope',sans-serif", transition: 'all .2s',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 9,
            opacity: sending ? .6 : 1,
            boxShadow: stars && !sending ? '0 5px 20px rgba(15,163,177,.38)' : 'none',
          }}>
            <Ic n="send" s={15}/>
            {sending ? 'Отправка...' : 'Отправить отзыв'}
          </button>
        </form>
      </Card>

      {/* Info note */}
      <div style={{
        display: 'flex', alignItems: 'flex-start', gap: 10,
        padding: '12px 16px', borderRadius: 12,
        background: isDark ? 'rgba(15,163,177,.05)' : 'rgba(15,163,177,.08)',
        border: '1px solid rgba(15,163,177,.15)',
      }}>
        <Ic n="info" s={14} style={{ color: c.teal, flexShrink: 0, marginTop: 1 }}/>
        <span style={{ fontSize: 12.5, color: c.muted, lineHeight: 1.65, fontFamily: "'Plus Jakarta Sans','Manrope',sans-serif" }}>
          Отзывы помогают нам улучшать сервис и помогают другим клиентам сделать правильный выбор.
        </span>
      </div>

    </div>
  )
}
